<div class="solo-rules-drawer" [ngStyle]="drawerStyles | theme">
  <app-nav-button
    icon="close"
    (clickEvent)="onCloseClick()"
    [variant]="drawerConfig.closeButtonInverted ? 'secondary' : 'primary'"
    [size]="drawerConfig.closeButtonSize"
    [ngClass]="drawerConfig.closeButtonPosition"
  />

  @if (rulesContent(); as content) {
    <div [@fadeIn] class="solo-rules-drawer-content">
      <div class="rules-display tournament-rules-markdown">
        <markdown [data]="content" [disableSanitizer]="true"></markdown>
      </div>
    </div>
  }
</div>
